'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { getChosenLocale } from '#pplx/frontend/i18n/browser.js';
import { memoizedLoadTranslations } from '#pplx/frontend/i18n/clientTranslations.js';
import { getTextDirection } from '#pplx/frontend/i18n/core.js';
import { TranslationsProvider } from '#pplx/frontend/i18n/provider.js';
import { DEFAULT_LOCALE } from '#pplx_generated/pplx/frontend/i18n/localeInfo.generated.js';
import React, { Suspense, use, useMemo } from 'react';
export const InnerClientTranslationsProvider = React.memo(function InnerClientTranslationsProvider({ locale, localeTranslations, children, }) {
    const { translations, matchedLocale } = use(memoizedLoadTranslations(locale, localeTranslations));
    return (_jsx(TranslationsProvider, { locale: matchedLocale, messages: translations, children: children }));
});
const EMPTY_OBJECT = {};
export const ClientTranslationsProvider = React.memo(function ClientTranslationsProvider({ children, locale: explicitLocale, shouldSetHtmlLang = true, localeTranslations, }) {
    const locale = useMemo(() => explicitLocale ?? getChosenLocale(), [explicitLocale]);
    const direction = useMemo(() => getTextDirection(locale), [locale]);
    if (shouldSetHtmlLang && typeof document !== 'undefined') {
        if (document.documentElement.lang !== locale) {
            document.documentElement.lang = locale;
        }
        if (document.documentElement.dir !== direction) {
            document.documentElement.dir = direction;
        }
    }
    // Return early here since Suspense is too lazy
    if (locale === DEFAULT_LOCALE) {
        return (_jsx(TranslationsProvider, { locale: locale, messages: EMPTY_OBJECT, children: children }));
    }
    return (_jsx(Suspense, { fallback: null, children: _jsx(InnerClientTranslationsProvider, { locale: locale, localeTranslations: localeTranslations, children: children }) }));
});
//# sourceMappingURL=clientProvider.js.map